export default "__VITE_ASSET__Dc5U4hno__"